import request from '@/utils/request'

export function login (username, password) {
  return request({
    url: '/login/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

// 修改密码
export function changepassword (username, oripassword, password) {
  return request({
    url: '/admin/updateUserPassword',
    method: 'post',
    params: {
      username: username,
      oripassword: oripassword,
      password: password
    }
  })
}

export function getInfo (token) {
  return request({
    url: '/admin/info',
    headers: {'Authorization': token},
    method: 'get'
  })
}

export function logout () {
  return request({
    url: '/login/logout',
    method: 'post'
  })
}

export function fetchList (params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin (data) {
  return request({
    url: '/admin/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin (id, data) {
  return request({
    url: '/admin/updateUserList',
    method: 'post',
    data: data
  })
}

export function updateStatus (id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin (id) {
  return request({
    url: '/admin/delUserList?id=' + id,
    method: 'post'
  })
}

export function getRoleByAdmin (id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole (data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js